import { Injectable } from '@angular/core';
import { ApiRestService } from './api-rest.service';
import {BehaviorSubject} from "rxjs";
import {Setting} from "../_models/setting";

@Injectable({
  providedIn: 'root'
})
export class SettingsStoreService {
  constructor(private ApiRestService: ApiRestService) { }
  private SETTINGS = new BehaviorSubject<Setting[]>([]);
  private SETTING = new BehaviorSubject<Setting>(null);
  private SettingsDataStore:{
    Settings: Setting[],
    Setting: Setting,
  } = {
    Settings: [],
    Setting: null,
  }
  readonly $settings = this.SETTINGS.asObservable();
  readonly $setting = this.SETTING.asObservable();
  refreshSettings = () => this.SETTINGS.next(Object.assign({},this.SettingsDataStore).Settings);
  refreshSetting = () => this.SETTING.next(Object.assign({},this.SettingsDataStore).Setting);

  GetListaSettings(){
    this.ApiRestService.ListSettings().subscribe( data => {
      this.SettingsDataStore.Settings = data;
      this.refreshSettings();
    });
  }

  updateSetting(value: Setting) {
    this.SettingsDataStore.Setting = value;
    this.refreshSetting();
  }

}
